<template>
    <div>
        <h2>Itens de Almoxarifado</h2>
        <div class="d-flex w-100 gap-10 search-form">
            <form class="w-100 flex-grow-1 d-flex" @change="getItensOs">
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="search"
                            clearable
                            hide-details
                            hide-selected
                            prepend-icon="mdi-magnify"
                            label="Search"
                            solo
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="itemCodigo"
                            clearable
                            hide-details
                            hide-selected
                            label="Código do Item"
                            solo
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="osSearch"
                            clearable
                            hide-details
                            hide-selected
                            label="OS"
                            solo
                        />
                    </v-col>
                </v-row>
            </form>

            <div class="text-center">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            :disabled="selected.length == 0"
                        >
                            Ações em Massa...
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(item, index) in actionsMassa"
                            :key="index"
                            :value="index"
                            @click="item.handle"
                            class="cursor-pointer"
                        >
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu>
            </div>
        </div>
        
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            class="elevation-1 mt-10 header-table text-no-wrap"
            disable-sort
            hide-default-footer
            :page.sync="page"
            item-value="name"
            show-select            
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            return-object
        >
        
            <template v-slot:[`item.ordemDeServico`]="{ item }">
                <span>
                    {{ item.ordemDeServico[0]?.codigo || "Não Informado" }}
                </span>
            </template>
            <template v-slot:[`item.job`]="{ item }">
                <span>
                    {{ item.ordemDeServico[0]?.jobCodigo || "Não Informado" }}
                </span>
            </template>
            <template v-slot:[`item.quantidade`]="{item}">
                <span>
                    {{ item.quantidade || 0 }}
                </span>
            </template>
            <template v-slot:[`item.quantidadeDisponivel`]="{ item }">
                <span>
                    {{ item.item?.saldoDeEstoque?.quantidadeDisponivel || 0 }}
                </span>
            </template>
            <template v-slot:[`item.dataNecessidade`]="{ item }">
                <span>
                    {{ new Date(item.dataNecessidade).toLocaleDateString() }}
                </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click="openHistorico(item)">
                            <v-icon small>mdi-history</v-icon>
                        </v-btn>
                    </template>
                    <span>Ver Histórico</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="historicoDialog" max-width="900" scrollable>
            <v-card>
                <v-card-title class="text-h6">
                    Histórico do Item
                    <span v-if="historicoItemSelected" class="ml-2 text-subtitle-1 grey--text">
                        — {{ historicoItemSelected.itemCodigo }} {{ historicoItemSelected.descricao }}
                    </span>
                    <v-spacer />
                    <v-btn icon @click="historicoDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text style="min-height: 300px;">
                    <v-progress-linear v-if="historicoLoading" indeterminate color="primary" />
                    <v-data-table
                        v-else
                        :headers="historicoHeaders"
                        :items="historicoItems"
                        disable-sort
                        hide-default-footer
                        :items-per-page="-1"
                        class="elevation-0"
                    >
                        <template v-slot:[`item.historicoDataCriacao`]="{ item }">
                            <span>{{ item.historicoDataCriacao ? new Date(item.historicoDataCriacao).toLocaleString() : '' }}</span>
                        </template>
                    </v-data-table>
                    <div v-if="!historicoLoading && historicoItems.length === 0" class="text-center py-6 grey--text">Nenhum histórico encontrado.</div>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <div class="text-center pt-2">
            <v-pagination
                v-model="page"
                :length="pageCount"
                @input="pagination"
            ></v-pagination>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService.js";

export default {
    name: 'ItensWarehouse',
    data() {
        return {
            search: '',
            osSearch: '',
            itemCodigo: '',
            selected: [],
            entityService: new EntityService('OrdemDeServicoItens'),
            entityServiceItem: new EntityService('Item'),
            entityServiceItemProdutoAcabado: new EntityService('ItensProdutoAcabado'),
            entityServiceOSItemUnidade: new EntityService('OrdemDeServicoItemUnidade'),
            entityServiceCollaborator: new EntityService('Collaborator'),
            entityServiceHistorico: new EntityService('HistoricoOrdemDeServicoItens'),
            historicoResponsavelId: '',
            historicoDialog: false,
            historicoLoading: false,
            historicoItems: [],
            historicoItemSelected: null,
            debugSolicitarFabricacao: true,
            historicoHeaders: [
                { text: 'Data/Hora', value: 'historicoDataCriacao' },
                { text: 'Descrição', value: 'historicoDescricao' },
                { text: 'Status', value: 'status' },
                { text: 'Quantidade', value: 'quantidade' },
                { text: 'Responsável', value: 'historicoResponsavel' },
            ],
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 0,
            headers: [
                { text: "JOB", value: "job" },
                { text: "OS", value: "ordemDeServico" },
                { text: "Seq", value: "sequencia" },
                { text: "Material", value: "itemCodigo" },
                { text: "Descrição", value: "descricao" },
                { text: "Unidade", value: "unidadeSigla" },
                { text: "Quantidade Solicitada", value: "quantidade" },
                { text: "Quantidade Disponivel", value: "quantidadeDisponivel" },
                { text: "Status", value: "status" },
                { text: "Prazo Desejado", value: "dataNecessidade"},
                { text: "", value: "actions", sortable: false, width: '50px' }
            ],
            actionsMassa: [
                { 
                    title: 'Enviar para Fabricação (SF)',
                    handle: () => {
                        this.sendSF()
                    }
                },
                { 
                    title: 'Enviar para Compras (SC)', 
                    handle: () => {
                        this.sendSC()
                    }
                },
                {
                    title: 'Reservar (RE)',
                    handle: () => {
                        this.sendRE()
                    }
                }
            ]
        }
    },

    methods: {
        async getItensOs(){
            try {
                const response = await Vue.prototype.$http.post('/View/run', {
                    "params": [
                        { dataType: "string", name: "descricao", value: this.search, },
                        { dataType: "string", name: "codigoOs", value: this.osSearch },
                        { dataType: "itemCodigo", name: 'itemCodigo', value: this.itemCodigo }
                    ],
                    "viewId": "9038198d-674a-4f8a-93e2-941760bf17a7",
                    "page": this.page,
                    "limit": 30
                });

                const lista = Array.isArray(response?.data?.data?.data) ? response.data.data.data : []

                const listaNormalizada = lista.map((itemRes = {}) => {
                    const ordemRaw = itemRes?.ordemDeServico
                    const ordemNormalizada = Array.isArray(ordemRaw)
                        ? ordemRaw
                        : (ordemRaw ? [ordemRaw] : [])

                    return {
                        ...itemRes,
                        ordemDeServico: ordemNormalizada,
                    }
                })

                this.items = listaNormalizada.filter((itemRes = {}) => {
                    const ordem = itemRes?.ordemDeServico?.[0] || {}
                    const osPreenchida = String(ordem?.codigo || '').trim() !== ''
                    const jobPreenchido = String(ordem?.jobCodigo || '').trim() !== ''
                    return osPreenchida && jobPreenchido
                })

                this.pageCount = Number(response?.data?.data?.pages || 0)
                this.itemsPerPage = Number(response?.data?.data?.limit || 30)
            } catch (error) {
                this.items = []
                this.pageCount = 0
                this.itemsPerPage = 30
                this.$notfy.error('Erro ao carregar itens de almoxarifado.')
                console.error('[ItensWarehouse][getItensOs] Erro ao carregar lista', error)
            }
        },

        async sendSF(){

            const getId = (value) => {
                if (value && typeof value === 'object') return value.id || value._id || value.userId || ''
                return value || ''
            }

            const normalize = (value) => String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase()

            const firstValue = (...values) => {
                for (const value of values) {
                    if (value !== undefined && value !== null && value !== '') return value
                }
                return ''
            }

            const toNumberQuantidade = (value) => {
                if (value === null || value === undefined || value === '') return 0
                if (typeof value === 'number') return Number.isFinite(value) ? value : 0

                const parsed = Number(String(value).replace(/\./g, '').replace(',', '.'))
                return Number.isFinite(parsed) ? parsed : 0
            }

            const toErpDate = (value = new Date()) => {
                const data = value instanceof Date ? value : new Date(value)
                if (Number.isNaN(data.getTime())) return ''
                const isoDate = data.toISOString().split('T')[0]
                return `${isoDate}T03:00:00.000Z`
            }

            const resolveOwnerIds = (osMae = {}, fallbackUserId = '') => {
                const ownersRaw = []

                if (Array.isArray(osMae?.owners)) ownersRaw.push(...osMae.owners)
                else if (osMae?.owners) ownersRaw.push(osMae.owners)

                if (Array.isArray(osMae?.owner)) ownersRaw.push(...osMae.owner)
                else if (osMae?.owner) ownersRaw.push(osMae.owner)

                const owners = [...new Set(ownersRaw.map((owner) => String(getId(owner) || '').trim()).filter(Boolean))]
                if (owners.length > 0) return owners

                const fallback = String(fallbackUserId || '').trim()
                return fallback ? [fallback] : []
            }

            const resolveJobItemId = (osMae = {}, osSelected = {}) => {
                const candidates = [
                    osMae?.jobItem,
                    osMae?.itemJob,
                    osSelected?.jobItem,
                    osSelected?.ordemDeServico?.[0]?.jobItem,
                ]

                for (const candidate of candidates) {
                    const id = String(getId(candidate) || '').trim()
                    if (id) return id
                }

                return undefined
            }

            const resolveDesenhoMontagem = (produtoAcabado = {}) => {
                const dadosProdutoAcabado = (produtoAcabado?._currentData && typeof produtoAcabado._currentData === 'object')
                    ? produtoAcabado._currentData
                    : produtoAcabado

                const desenho = String(firstValue(
                    dadosProdutoAcabado?.desenhoNumero,
                    dadosProdutoAcabado?.['Numero do Desenho'],
                    dadosProdutoAcabado?.numero_do_desenho,
                    dadosProdutoAcabado?.numeroDoDesenho,
                    dadosProdutoAcabado?.numeroDesenho,
                    dadosProdutoAcabado?.numero_desenho,
                    dadosProdutoAcabado?.drawingNumber,
                    produtoAcabado?.desenhoNumero,
                    produtoAcabado?.numeroDoDesenho,
                    produtoAcabado?.numeroDesenho,
                    produtoAcabado?.numero_desenho,
                    produtoAcabado?.drawingNumber,
                    produtoAcabado?.desenhoDeMontagem,
                    produtoAcabado?.desenhoMontagem,
                    produtoAcabado?.assemblyDrawing,
                    ''
                ) || '').trim()

                const posicao = String(firstValue(
                    dadosProdutoAcabado?.desenhoItemPosicao,
                    dadosProdutoAcabado?.['Posição do Item no Desenho'],
                    dadosProdutoAcabado?.['Posicao do Item no Desenho'],
                    dadosProdutoAcabado?.posicao_do_item_no_desenho,
                    dadosProdutoAcabado?.posicaoDoItemNoDesenho,
                    dadosProdutoAcabado?.posicaoItemNoDesenho,
                    dadosProdutoAcabado?.posicaoNoDesenho,
                    dadosProdutoAcabado?.posicao,
                    dadosProdutoAcabado?.desenhoPosicao,
                    dadosProdutoAcabado?.desenho_posicao,
                    dadosProdutoAcabado?.drawingPosition,
                    produtoAcabado?.desenhoItemPosicao,
                    produtoAcabado?.posicaoDoItemNoDesenho,
                    produtoAcabado?.posicaoItemNoDesenho,
                    produtoAcabado?.posicaoNoDesenho,
                    produtoAcabado?.posicao,
                    produtoAcabado?.desenhoPosicao,
                    produtoAcabado?.desenho_posicao,
                    produtoAcabado?.drawingPosition,
                    produtoAcabado?.desenhoDeMontagemPosicao,
                    produtoAcabado?.desenhoMontagemPosicao,
                    produtoAcabado?.assemblyDrawingPosition,
                    ''
                ) || '').trim()

                if (desenho && posicao) return `${desenho}/${posicao}`
                return desenho
            }

            const resolveSequencia = (produtoAcabado = {}, index = 0) => {
                const sequencia = firstValue(produtoAcabado?.sequencia, produtoAcabado?.sequence, produtoAcabado?.seq, index + 1)
                const numero = Number.parseInt(String(sequencia || '').replace(/\D/g, ''), 10)
                if (Number.isFinite(numero) && numero > 0) return String(numero).padStart(3, '0')
                return String(index + 1).padStart(3, '0')
            }

            const buildUnidadeLookup = (lista = []) => {
                return Array.isArray(lista) ? lista.map((unidade = {}) => ({
                    raw: unidade,
                    id: String(getId(unidade) || '').trim(),
                    descricao: normalize(firstValue(unidade?.descricao, unidade?.description, unidade?.name, unidade?.nome, '')),
                    sigla: normalize(firstValue(unidade?.sigla, unidade?.code, unidade?.codigo, '')),
                })) : []
            }

            const resolveUnidadeOSItem = (produtoAcabado = {}, osSelected = {}, lookup = []) => {
                const descricaoFonte = normalize(firstValue(
                    produtoAcabado?.unidade?.descricao,
                    produtoAcabado?.unidade?.description,
                    produtoAcabado?.descricaoUnidade,
                    produtoAcabado?.unidadeDescricao,
                    osSelected?.unidade?.descricao,
                    osSelected?.unidadeDescricao,
                    ''
                ))

                const siglaFonte = normalize(firstValue(
                    produtoAcabado?.unidade?.sigla,
                    produtoAcabado?.unidade?.code,
                    produtoAcabado?.siglaUnidade,
                    produtoAcabado?.unidadeSigla,
                    osSelected?.unidadeSigla,
                    osSelected?.siglaUnidade,
                    ''
                ))

                let unidade = null
                if (descricaoFonte) {
                    unidade = lookup.find((item = {}) => item.descricao && item.descricao === descricaoFonte) || null
                }

                if (!unidade && siglaFonte) {
                    unidade = lookup.find((item = {}) => item.sigla && item.sigla === siglaFonte) || null
                }

                return unidade?.raw || null
            }

            const logFabricacao = (...args) => {
                if (!this.debugSolicitarFabricacao) return
                console.log(...args)
            }

            let newsOs = []
            const contextosFabricacao = []

            const user = await this.$auth.getUserParams();
            const userId = String(user?.userId || user?.id || '').trim()

            const ids = this.selected
                .map((itemSelected) => getId(itemSelected?.item?.id || itemSelected?.item))
                .filter(Boolean)
                .join(',')

            let osItems = []
            if(ids){
                const response = await this.entityServiceItem.getAll(1, 1000, null, null, ids, null, null)
                osItems = response?.data?.data?.data || []
            }

            const responseUnidades = await this.entityServiceOSItemUnidade.getAll(1, 1000, '', '', null, null, null, 'sigla')
            const unidadesOSItem = responseUnidades?.data?.data?.data || []
            const unidadeLookup = buildUnidadeLookup(unidadesOSItem)

            const selectedContexts = this.selected.map((selectedItem, index) => ({
                index,
                selectedItem,
                sourceItemId: String(getId(selectedItem?.item?.id || selectedItem?.item) || '').trim(),
                sourceOsItemId: String(getId(selectedItem?.id) || '').trim(),
            }))
            const selectedUsed = new Set()

            for (const osItem of osItems) {
                const itemId = String(getId(osItem?.id) || '').trim()
                const contextIndex = selectedContexts.findIndex((contexto) => !selectedUsed.has(contexto.index) && contexto.sourceItemId === itemId)
                if (contextIndex === -1) continue

                selectedUsed.add(selectedContexts[contextIndex].index)

                const osSelected = selectedContexts[contextIndex].selectedItem
                const osMae = osSelected?.ordemDeServico?.[0] || {}
                const quantidadeItemPrincipalOrigem = Math.max(toNumberQuantidade(firstValue(
                    osSelected?.quantidade,
                    osSelected?.item?.quantidade,
                    osSelected?.itemQuantidade,
                    1
                )), 1)
                const valorTotalItemOrigem = toNumberQuantidade(firstValue(
                    osSelected?.valorTotal,
                    osSelected?.precoTotal,
                    osSelected?.item?.valorTotal,
                    osSelected?.item?.precoTotal,
                    0
                ))
                const dataSolicitacaoCriacao = toErpDate(new Date())
                const dataNecessidadeReferencia = toErpDate(osSelected?.dataNecessidade || new Date())
                const ownersFilha = resolveOwnerIds(osMae, userId)
                const itemOrdemDeServicoMaeId = String(getId(osSelected?.id) || '').trim()
                const itensProdutoAcabadoIds = Array.isArray(osItem?.itens) ? osItem.itens.map((item) => getId(item)).filter(Boolean) : []

                let itensProdutoAcabado = []
                if (itensProdutoAcabadoIds.length > 0) {
                    const responseItensProdutoAcabado = await this.entityServiceItemProdutoAcabado.getAll(1, 1000, null, null, itensProdutoAcabadoIds.join(','), null, null)
                    itensProdutoAcabado = responseItensProdutoAcabado?.data?.data?.data || []
                }

                const osProdutoAcabado = itensProdutoAcabado
                    .map((produtoAcabado, index) => {
                        const sequencia = resolveSequencia(produtoAcabado, index)
                        const quantidadeBase = Math.max(toNumberQuantidade(produtoAcabado?.quantidade), 0)
                        const quantidadeItem = Number((quantidadeBase * quantidadeItemPrincipalOrigem).toFixed(6))
                        const valorUnitario = 0.01
                        const valorTotal = Number((quantidadeItem * valorUnitario).toFixed(2))
                        const unidadeResolvida = resolveUnidadeOSItem(produtoAcabado, osSelected, unidadeLookup)
                        const unidadeId = String(getId(unidadeResolvida) || '').trim()
                        const unidadeSigla = firstValue(unidadeResolvida?.sigla, unidadeResolvida?.code, unidadeResolvida?.codigo, osSelected?.unidadeSigla, '')

                        const payloadItemOS = {
                            sequencia,
                            item: produtoAcabado.item,
                            descricao: firstValue(produtoAcabado?.itemDescricao, produtoAcabado?.descricao, osItem?.description, osSelected?.descricao, ''),
                            status: 'LA',
                            destino: 'ND',
                            dataSolicitacao: dataSolicitacaoCriacao,
                            dataNecessidade: dataNecessidadeReferencia,
                            quantidade: quantidadeItem,
                            quantidadeParaEmbarcar: quantidadeItem,
                            valorUnitario,
                            valorTotal,
                            desenhoMontagem: resolveDesenhoMontagem(produtoAcabado),
                        }

                        if (unidadeId) payloadItemOS.unidade = unidadeId
                        if (unidadeSigla) payloadItemOS.unidadeSigla = unidadeSigla

                        return payloadItemOS
                    })
                    .sort((a, b) => Number.parseInt(a.sequencia, 10) - Number.parseInt(b.sequencia, 10))

                const itensOF = osProdutoAcabado.map((item) => ({
                    seq: Number.parseInt(item.sequencia, 10) || 0,
                    qty: item.quantidade,
                    itemId: item.item,
                    itemOrdemDeServico: itemOrdemDeServicoMaeId,
                }))

                const jobItemFilha = resolveJobItemId(osMae, osSelected)

                const newsOsPayload = {
                    osMae: getId(osMae?._id || osMae?.id),
                    job: osMae?.job,
                    jobItem: jobItemFilha,
                    coordenadorDeProjetos: osMae?.coordenadorDeProjetos,
                    osTipo: 'Fabricação',
                    valorDisponivel: valorTotalItemOrigem,
                    dataEncerramentoPrevista: osMae?.dataEncerramentoPrevista,
                    dataEncerramento: osMae?.dataEncerramento,
                    itens: [],
                    dataSolicitacao: dataSolicitacaoCriacao,
                    itemOrdemDeServico: itemOrdemDeServicoMaeId,
                    descricao: osItem?.description,
                    osQuantidade: quantidadeItemPrincipalOrigem,
                    classificacaoContabil: osItem?.classificacao,
                    owners: ownersFilha,
                }

                const contexto = {
                    itemId,
                    quantidadeItemPrincipalOrigem,
                    osMae,
                    osItem,
                    osSelected,
                    itemOrdemDeServicoMaeId,
                    dataSolicitacaoCriacao,
                    dataNecessidadeReferencia,
                    newsOsPayload,
                    osProdutoAcabado,
                    itensOF,
                }

                if (this.debugSolicitarFabricacao) {
                    console.groupCollapsed(`[SF][debug] preparação item ${itemId}`)
                    console.log('OS mãe', osMae)
                    console.log('Selecionado', osSelected)
                    console.log('Payload OS filha', newsOsPayload)
                    console.log('Payload itens OS filha', osProdutoAcabado)
                    console.log('Payload itens ordem fabricação', itensOF)
                    console.groupEnd()
                }

                contextosFabricacao.push(contexto)
            }

            for (const contexto of contextosFabricacao) {
                if (contexto.osProdutoAcabado.length === 0) continue

                const responseItensOS = await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeServicoItens', contexto.osProdutoAcabado)
                const itensCriados = Array.isArray(responseItensOS?.data?.data) ? responseItensOS.data.data : []
                contexto.itensServicoResponse = itensCriados
                contexto.newsOsPayload.itens = itensCriados.map((item) => item.id)

                logFabricacao('[SF][debug] resposta insertMany/OrdemDeServicoItens', {
                    itemId: contexto.itemId,
                    response: itensCriados,
                })
            }

            newsOs = contextosFabricacao.map((contexto) => contexto.newsOsPayload)

            if(newsOs.length > 0){
                logFabricacao('[SF][debug] payload insertMany/OrdemDeServico', newsOs)

                const responsePostMany = await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeServico', newsOs);
                const osCriadas = Array.isArray(responsePostMany?.data?.data) ? responsePostMany.data.data : []

                const itensOrdemFabricacaoPayload = contextosFabricacao.flatMap((contexto, index) => {
                    const osCriada = osCriadas[index] || {}
                    return contexto.itensOF.map((fab) => ({
                        ...fab,
                        osFilha: osCriada.codigo,
                    }))
                })

                logFabricacao('[SF][debug] payload insertMany/ItensOrdemDeFabricacao', itensOrdemFabricacaoPayload)

                const responseItensOrdemFabricacao = await Vue.prototype.$http.post('/Entity/insertMany/ItensOrdemDeFabricacao', itensOrdemFabricacaoPayload);
                const itensOrdem = Array.isArray(responseItensOrdemFabricacao?.data?.data) ? responseItensOrdemFabricacao.data.data : []

                let cursorItensOF = 0
                contextosFabricacao.forEach((contexto) => {
                    const quantidadeItens = contexto.itensOF.length
                    contexto.itensOFCriados = itensOrdem.slice(cursorItensOF, cursorItensOF + quantidadeItens)
                    cursorItensOF += quantidadeItens
                })

                const ordemFabricacao = osCriadas.map((os, index) => {
                    const contexto = contextosFabricacao[index] || {}

                    return {
                        status: 'Pendente',
                        job: os.jobCodigo,
                        solicitante: 'Almoxarifado',
                        os: os.osMaeCodigo,
                        cliente: '',
                        produto: os.descricao,
                        osItem: contexto.itemOrdemDeServicoMaeId,
                        itens: Array.isArray(contexto.itensOFCriados) ? contexto.itensOFCriados.map((item) => item.id) : [],
                    }
                })

                logFabricacao('[SF][debug] payload insertMany/OrdemDeFabricacao', ordemFabricacao)

                await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeFabricacao', ordemFabricacao);

                if(responsePostMany.data.success){
                    this.changeStatus("SF", this.selected)
                    await this.sendAlert("SF", "70e6be18-e95a-4201-8d7f-d61a7af271da", 'Realizaer liberação de OS filha (fabricação)') // Gabriel Marcos de Rosa Miari
                    this.selected = []
                } else {
                    this.$notfy.error("Erro ao atualizar os itens.");
                }

            }
/*
            if(itensSendSC.length > 0) {
                this.changeStatus("SC", itensSendSC)
                await this.sendAlert("SC", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
            }*/

        },

        async sendSC() {
            this.changeStatus("SC", this.selected)
            await this.sendAlert("SC", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
        },

        async sendRE(){

            if(this.selected.some((select) => (select?.item?.saldoDeEstoque?.quantidadeDisponivel || 0) < select?.quantidade)){
                this.$notfy.error("Não é possível reservar itens com quantidade disponível menor que a quantidade solicitada.")
                return
            }
            
            await Promise.allSettled([
                this.updateStockBalance(this.selected),
                this.changeStatus("RE", this.selected),
                this.sendAlert("RE", "70e6be18-e95a-4201-8d7f-d61a7af271da", 'Realizaer reserva de material'), // Gabriel Marcos de Rosa Miari
                this.sendAlert("RE", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
            ])
        },

        async updateStockBalance(itemsSelected){
            itemsSelected.map(async (item) => {

                const response = await Vue.prototype.$http.get(`/Entity/StockBalance/${item?.item?.saldoDeEstoque.id}`);

                delete response.data.data.createAt
                delete response.data.data.updatedAt
                delete response.data.data.updateBy
                delete response.data.data.createBy
                delete response.data.data.deleteAt
                delete response.data.data.deleteBy

                await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                    ...response.data.data,
                    quantidadeDisponivel: response.data.data.quantidadeDisponivel - item.quantidade,
                    quantidadeReservado: response.data.data.quantidadeReservado + item.quantidade,
                    dataAlteracao: new Date().toISOString().split("T")[0] + "T03:00:00Z"
                })
            })
        },

        async changeStatus(status, itemsSelected){
            await this.saveHistoricChange(status)

            itemsSelected.map((item) => {

                delete item?.createAt
                delete item?.updatedAt
                delete item?.updateBy
                delete item?.createBy
                delete item?.updateBy
                delete item?.deleteAt
                delete item?.deleteBy
                delete item?.ordemDeServico

                item.item = item.item.id

                item.status = status

            })

            const response = await Vue.prototype.$http.put('/Entity/updateMany/OrdemDeServicoItens', itemsSelected);

            if(response.data.success){
                this.$notfy.success(`Items enviados para ${status}.`);
                this.getItensOs()

                this.selected = []

            } else {
                this.$notfy.error("Erro ao atualizar os itens.");
            }
        },

        async saveHistoricChange(status){
            let itemsPost = []

            const user = await this.$auth.getUserParams();
            const dataHistorico = new Date().toISOString();

            const resolveHistoricoResponsavelId = async () => {
                if (this.historicoResponsavelId) return this.historicoResponsavelId

                try {
                    const colaboradorSalvo = JSON.parse(window.localStorage.getItem('ColaboradorStore') || '{}')
                    const colaboradorIdSalvo = String(colaboradorSalvo?.id || '').trim()
                    if (colaboradorIdSalvo) {
                        this.historicoResponsavelId = colaboradorIdSalvo
                        return colaboradorIdSalvo
                    }
                } catch (_) {
                    // segue para fallback
                }

                try {
                    const userId = String(user?.userId || user?.id || '').trim()
                    if (userId) {
                        const collaboratorSearch = await this.entityServiceCollaborator.search('user', userId, 1, 1, null, null, null)
                        const collaborator = collaboratorSearch?.data?.data?.data?.[0] || null
                        const collaboratorId = String(collaborator?.id || collaborator?._id || '').trim()
                        if (collaboratorId) {
                            this.historicoResponsavelId = collaboratorId
                            return collaboratorId
                        }
                    }
                } catch (_) {
                    // mantém fallback final
                }

                return ''
            }

            const historicoResponsavelId = await resolveHistoricoResponsavelId()

            this.selected.map((item) => {
                itemsPost.push({
                    novo_status: status,
                    itemId: item.item.id,
                    os: item?.ordemDeServico[0]?.codigo,
                    osItem: item.id,
                    date_change: new Date().toISOString().split("T")[0] + "T03:00:00Z",
                    time: new Date().toLocaleTimeString(),
                    user: user.user
                })
            })

            console.log('itemsPost >>> ', itemsPost)

            await Vue.prototype.$http.post('/Entity/insertMany/HistoricoMudancaStatus', itemsPost)

            try {
                const sanitizarPayloadHistoricoOS = (itemOS = {}) => {
                    const payload = { ...itemOS }

                    // Campos de auditoria/controlados pelo backend
                    delete payload.id
                    delete payload._id
                    delete payload.createAt
                    delete payload.createBy
                    delete payload.updateAt
                    delete payload.updatedAt
                    delete payload.updateBy
                    delete payload.deleteAt
                    delete payload.deleteBy
                    delete payload.isDeleted
                    delete payload.owners

                    // Relacionamentos/estruturas que não fazem parte do schema de histórico
                    delete payload.ordemDeServico
                    delete payload.item
                    delete payload.unidade
                    delete payload.unidadeCompra
                    delete payload.fornecedor

                    // Remove qualquer campo interno do client e valores complexos
                    Object.keys(payload).forEach((key) => {
                        if (key.startsWith('_')) {
                            delete payload[key]
                            return
                        }

                        const value = payload[key]
                        if (Array.isArray(value)) {
                            delete payload[key]
                            return
                        }

                        if (value !== null && typeof value === 'object') {
                            delete payload[key]
                        }
                    })

                    return payload
                }

                const idsSelecionados = this.selected
                    .map((item) => item?.id)
                    .filter(Boolean)
                    .join(',')

                if (!idsSelecionados) return

                const itensResponse = await this.entityService.getAll(1, 1000, null, null, idsSelecionados, null, null)
                const itensDaOS = itensResponse?.data?.data?.data || []

                if (!Array.isArray(itensDaOS) || itensDaOS.length === 0) return

                const historicoOSItens = itensDaOS.map((itemOS = {}) => {
                    const ordemDeServicoItemId = itemOS?.id || itemOS?._id
                    const itemHistorico = sanitizarPayloadHistoricoOS(itemOS)

                    return {
                        ...itemHistorico,
                        historicoResponsavel: historicoResponsavelId,
                        historicoDataCriacao: dataHistorico,
                        historicoDescricao: `Status alterado para ${status}`,
                        ordemDeServicoItem: ordemDeServicoItemId,
                    }
                }).filter((itemHistorico) => itemHistorico.ordemDeServicoItem && itemHistorico.historicoResponsavel)

                if (historicoOSItens.length > 0) {
                    await Vue.prototype.$http.post('/Entity/insertMany/HistoricoOrdemDeServicoItens', historicoOSItens)
                }
            } catch (error) {
                console.error('Erro ao salvar histórico da OS:', error)
            }
            
        },
        
        pagination(page) {
            this.page = page
            this.getItensOs()
        },

        async openHistorico(item) {
            this.historicoItemSelected = item
            this.historicoDialog = true
            this.historicoLoading = true
            this.historicoItems = []
            try {
                const response = await this.entityServiceHistorico.getAll(
                    1, 1000, item.id, ['ordemDeServicoItem'], null, 'Equals', null, 'historicoDataCriacao'
                )
                const records = response?.data?.data?.data || response?.data?.data || []
                this.historicoItems = records.slice().sort((a, b) => {
                    return new Date(b.historicoDataCriacao) - new Date(a.historicoDataCriacao)
                })
            } catch (e) {
                console.error('Erro ao buscar histórico:', e)
            } finally {
                this.historicoLoading = false
            }
        },

        async sendAlert(status, userId, description){
            await Vue.prototype.$http.post('/Entity/Alert',
                {
                    title: `Atenção, item de OS foi enviado para ${status}`,
                    description,
                    link: '',
                    view: 'Não',
                    //schemaRecordId: schemaRecordId,
                    user: userId
                },
            )
        }
    },

    async created(){
        await this.getItensOs()
    },

    watch: {
        selected(values){
            console.log('VALUES >>> ', values)
            // this.saveHistoricChange("RE")
        }
    }
}
</script>

<style scoped>
    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
    .header-table thead tr {
        position: sticky;
        top: 0;
        right: 0;
        background-color: #fff;
    }

</style>